import './index.css';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { forwardRef, useState } from 'react';
import { ChipsTrigger } from './ChipsTrigger.js';
import 'classnames';
import '@hh.ru/magritte-common-keyboard';
import '@hh.ru/magritte-common-use-multiple-refs';
import '@hh.ru/magritte-ui-breakpoint';
import '@hh.ru/magritte-ui-chips';
import '@hh.ru/magritte-ui-form-helper';
import '@hh.ru/magritte-ui-icon/icon';
import '@hh.ru/magritte-ui-input/useFocus';

const DEFAULT_STATE = {
    value: '',
    chips: [],
};
const UncontrolledChipsTrigger = forwardRef(({ state: defaultState = DEFAULT_STATE, onChange, name, ...restProps }, ref) => {
    const [state, setState] = useState({ ...defaultState });
    return (jsxs(Fragment, { children: [jsx(ChipsTrigger, { ...restProps, state: state, onChange: (newState) => {
                    setState(newState);
                    onChange?.(newState);
                }, ref: ref }), state.chips.map((chip) => (jsx("input", { type: "hidden", name: name, value: chip.value }, chip.value)))] }));
});
UncontrolledChipsTrigger.displayName = 'UncontrolledChipsTrigger';

export { UncontrolledChipsTrigger };
//# sourceMappingURL=UncontrolledChipsTrigger.js.map
